import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors';
import es from 'vuetify/es5/locale/es';
import ca from 'vuetify/es5/locale/ca';
import en from 'vuetify/es5/locale/en';
import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

const opts = {
	theme: {
		light: true,
		themes: {
			light: {
				primary: '#166bf2',
				secondary: '#e56208',
				accent: colors.orange.darken1,
				error: colors.red.darken1
			}
		}
	},
	icons: {
		iconfont: 'fa'
	},
	lang: {
		locales: { en, es, ca, fr },
		current: 'es'
	}
};

export default new Vuetify(opts);
